import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditAllocationWarningRequestPending() {
      return getState().request.isPending;
    },
    isEditAllocationWarningRequestSuccess() {
      return getState().request.isSuccessful;
    },
    isEditAllocationWarningRequestFailure() {
      return getState().request.isFailure;
    },
  };
}

export { createSelector };
